import { observer } from "mobx-react-lite"
import { ActionIcon, Box, Button, Group, Select, TextInput } from "@mantine/core"
import { brandSelectValues } from "./config"
import { IconTrash } from "@tabler/icons-react"
import { useFormContext } from "./formContext"

export const SocialFields = observer(function SocialFields() {
  const form = useFormContext()

  const addField = () => form.insertListItem("socials", { brand: "vk", url: "" })

  return (
    <Box w="100%">
      {
        form.values.socials.map((item, index) => (
          <Group key={`${item.url}_${index}`} spacing="xl" mb="xl">
            <Select
              label="Социальная сеть"
              data={brandSelectValues}
              {...form.getInputProps(`socials.${index}.brand`)}
            />

            <TextInput
              label="Ссылка"
              placeholder="https://vk.ru"
              sx={{ flex: 1 }}
              {...form.getInputProps(`socials.${index}.url`)}
            />
            <ActionIcon
              color="red"
              onClick={() => form.removeListItem("socials", index)}
              mt={26}
            >
              <IconTrash size="1rem"/>
            </ActionIcon>
          </Group>
        ))
      }

      <Group position="left">
        <Button onClick={addField}>
          Добавить соц. сеть
        </Button>
      </Group>
    </Box>
  )
})
